import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Importando imagens das modalidades
import musculacao from '../assets/images/modalidade_musculacao.jpeg';
import funcional from '../assets/images/modalidade_funcional.jpeg';
import hidroginastica from '../assets/images/modalidade_hidroginastica.jpeg';
import karate from '../assets/images/modalidade_karate.jpeg';
import ritbox from '../assets/images/modalidade_ritbox.png';
import fitdance from '../assets/images/modalidade_fitdance.png';

// Importando imagens das unidades
import unidadeLucianoCavalcante from '../assets/images/unidade_luciano_cavalcante.jpeg';
import unidadeMessejana from '../assets/images/unidade_messejana.png';

const Home: React.FC = () => {
  // Animação para elementos que aparecem ao rolar
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // Lista de modalidades para exibir na seção
  const modalidades = [
    { id: 1, nome: 'Musculação', imagem: musculacao },
    { id: 2, nome: 'Treinamento Funcional', imagem: funcional },
    { id: 3, nome: 'Hidroginástica', imagem: hidroginastica },
    { id: 4, nome: 'Karatê', imagem: karate },
    { id: 5, nome: 'Ritbox', imagem: ritbox },
    { id: 6, nome: 'Fitdance', imagem: fitdance }
  ];

  // Lista de unidades
  const unidades = [
    { 
      id: 1, 
      nome: 'Luciano Cavalcante', 
      endereco: 'Rua Esperança, 56', 
      cep: 'CEP 60.811-243', 
      imagem: unidadeLucianoCavalcante 
    },
    { 
      id: 2, 
      nome: 'Messejana', 
      endereco: 'Rua Chico França, 720', 
      cep: 'CEP 60.871-100', 
      imagem: unidadeMessejana 
    }
  ];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{ 
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(/slide-background.jpg)` 
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
              ACADEMIA <span className="text-primary">TOPSPIN</span>FIT
            </h1>
            <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">
              Na TopSpinFit você nunca mais vai se sentir perdido nem desanimado nos treinos. 
              Oferecemos atendimento com treinos personalizados, conforto e segurança.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a href="https://academiatopspinfit.sitesca.com/matricular" target="_blank" rel="noopener noreferrer" className="btn btn-primary text-lg">
                Matrícula Online
              </a>
              <Link to="/modalidades" className="btn btn-secondary text-lg">
                Conheça Nossas Modalidades
              </Link>
            </div>
          </motion.div>
        </div>
        
        {/* Scroll indicator */}
        <motion.div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
        >
          <svg 
            className="w-10 h-10 text-white" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 14l-7 7m0 0l-7-7m7 7V3" 
            />
          </svg>
        </motion.div>
      </section>

      {/* Sobre Nós */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <h2 className="section-title">Somos a Academia <span className="text-primary">Top Spin Fit</span></h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-bold mb-4">Nossa Missão</h3>
                <p className="text-gray-700 mb-6">
                  Oferecer excelência em atendimento e prestação de serviços na orientação de atividades físicas 
                  para proporcionar qualidade de vida e bem estar aos nossos clientes, com profissionalismo, 
                  bom humor e ambiente acolhedor.
                </p>
                
                <h3 className="text-2xl font-bold mb-4">Nossa Visão</h3>
                <p className="text-gray-700 mb-6">
                  Ser referência na região em excelência de atendimento e qualidade dos serviços prestados, 
                  conquistar o entusiasmo de nossos clientes através da melhoria contínua, alcançada pelo 
                  trabalho em equipe e pela capacidade de inovar do Time TopSpinFit.
                </p>
                
                <Link to="/nossa-academia" className="btn btn-secondary">
                  Conheça Nossa História
                </Link>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition-transform">
                  <img 
                    src={unidadeLucianoCavalcante} 
                    alt="Academia TopSpinFit" 
                    className="w-full h-64 object-cover"
                  />
                </div>
                <div className="rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition-transform mt-8">
                  <img 
                    src={unidadeMessejana} 
                    alt="Academia TopSpinFit" 
                    className="w-full h-64 object-cover"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Modalidades */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <h2 className="section-title">Nossas <span className="text-primary">Modalidades</span></h2>
            <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">
              Oferecemos diversas modalidades para você escolher a que mais combina com seu estilo e objetivos.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {modalidades.map((modalidade) => (
                <div 
                  key={modalidade.id}
                  className="card group"
                >
                  <div className="relative overflow-hidden">
                    <img 
                      src={modalidade.imagem} 
                      alt={modalidade.nome} 
                      className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                      <h3 className="text-white text-xl font-bold p-6">{modalidade.nome}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-12">
              <Link to="/modalidades" className="btn btn-secondary">
                Ver Todas as Modalidades
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Unidades */}
      <section className="py-20 bg-secondary text-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <h2 className="section-title text-white">Nossas <span className="text-primary">Unidades</span></h2>
            <p className="text-xl text-gray-300 text-center max-w-3xl mx-auto mb-12">
              Estamos presentes em dois locais estratégicos de Fortaleza para melhor atender você.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {unidades.map((unidade) => (
                <div 
                  key={unidade.id}
                  className="bg-gray-900 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
                >
                  <img 
                    src={unidade.imagem} 
                    alt={`Unidade ${unidade.nome}`} 
                    className="w-full h-64 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-primary mb-2">{unidade.nome}</h3>
                    <p className="text-gray-300 mb-1">{unidade.endereco}</p>
                    <p className="text-gray-300 mb-4">{unidade.cep}</p>
                    <Link to={`/unidades#${unidade.id}`} className="btn btn-primary">
                      Ver Detalhes
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* App Download */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Baixe o nosso aplicativo <span className="text-primary">SCA ALUNO</span>
              </h2>
              <p className="text-gray-700 mb-6">
                Potencialize seus treinos e acompanhe seu progresso em qualquer lugar! 
                Baixe agora mesmo nosso aplicativo de treino e tenha acesso a rotinas personalizadas, 
                dicas exclusivas e muito mais. Transforme seu celular em seu melhor aliado fitness e 
                leve a TopsinFit com você para onde quer que vá.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="https://play.google.com/store/apps/details?id=com.sistemasca.scafit&hl=pt_BR&gl=US" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
                  <img src="/google-play-badge.png" alt="Google Play" className="h-14" />
                </a>
                <a href="https://apps.apple.com/br/app/sca-aluno/id1630928165" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
                  <img src="/app-store-badge.png" alt="App Store" className="h-14" />
                </a>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="flex justify-center"
            >
              <img 
                src="/app_mockup.png" 
                alt="Aplicativo TopSpinFit" 
                className="max-w-full h-auto shadow-2xl rounded-3xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-primary">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
            Pronto para começar sua transformação?
          </h2>
          <p className="text-xl text-gray-800 mb-8 max-w-3xl mx-auto">
            Junte-se à comunidade TopSpinFit e descubra como podemos ajudar você a alcançar seus objetivos.
          </p>
          <a href="https://academiatopspinfit.sitesca.com/matricular" target="_blank" rel="noopener noreferrer" className="btn btn-secondary text-lg px-8 py-4">
            Faça sua Matrícula Agora
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
